// extracted by mini-css-extract-plugin
export default {"selectContainer":"Select_selectContainer__mVKkP","icon":"Select_icon__0YWR5"};